// /center/compare DataGrid 컬럼 정의.
// 예외 화면(useSelect 기반 필터 유지)이라 컬럼만 분리한다.
// flex 전면 제거 → width + minWidth 고정. 넘치는 컬럼은 그리드 내부 가로 스크롤로 처리된다.

import React from "react";
import { Link } from "react-router-dom";
import { EditButton } from "@refinedev/mui";
import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { OverflowTooltip } from "components/list";
import { IComparisonCenter } from "../interfaces";

// 셀 내 링크는 프라이머리 토큰(라이트/다크 공용)
const linkStyle: React.CSSProperties = {
  textDecoration: "underline",
  fontWeight: 600,
  color: "var(--color-primary)",
};

export const compareCentersColumns: GridColDef<IComparisonCenter>[] = [
  { field: "id", headerName: "ID", type: "number", width: 84, minWidth: 72, align: "center", headerAlign: "center" },
  {
    field: "name",
    headerName: "이름",
    width: 200,
    minWidth: 140,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={params.value}>
        <Link to={`/center/compare/show/${params.row.id}`} style={linkStyle}>
          {params.value}
        </Link>
      </OverflowTooltip>
    ),
  },
  {
    field: "kindOf",
    headerName: "종류",
    width: 100,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      let kindText = "";
      if (params.value === "Kindergarten") {
        kindText = "유치원";
      } else if (params.value === "ChildHouse") {
        kindText = "어린이집";
      } else {
        kindText = "기타";
      }
      return <OverflowTooltip value={kindText} />;
    },
  },
  { field: "address", headerName: "주소", width: 502, minWidth: 420 },
  { field: "sido", headerName: "시도", width: 110, minWidth: 90 },
  { field: "sigungu", headerName: "시군구", width: 120, minWidth: 100 },
  { field: "estType", headerName: "유형", width: 150, minWidth: 125, align: "center", headerAlign: "center" },
  { field: "status", headerName: "상태", width: 96, minWidth: 80, align: "center", headerAlign: "center" },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    minWidth: 90,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <div>
        <EditButton hideText recordItemId={params.row.id} />
      </div>
    ),
  },
];
